import React from 'react'
import { Box, IconButton } from '@mui/material'
import CustomTooltip from 'src/designSystem/CustomTooltip'
import { ChevronsIcon, SidebarIcon } from 'src/designSystem/icons'
import { useSidebarControls } from 'src/designSystem/Container/sidebarControls'
import { trackParticipantListLayoutChanged } from 'src/mixpanel'

const ParticipantListControls = () => {
  const { isCollapsed, isExpanded, toggleCollapsed, toggleExpanded } = useSidebarControls()

  const onToggleCollapsed = () => {
    trackParticipantListLayoutChanged(isCollapsed ? 'show' : 'hide')
    toggleCollapsed()
  }

  const onToggleExpanded = () => {
    trackParticipantListLayoutChanged(isExpanded ? 'shrink' : 'expand')
    toggleExpanded()
  }

  return (
    <Box display="flex" alignItems="center">
      <CustomTooltip title={isCollapsed ? 'Show participant list' : 'Hide participant list'}>
        <IconButton
          size="small"
          onClick={onToggleCollapsed}
          aria-label={isCollapsed ? 'show participant list' : 'hide participant list'}
        >
          <SidebarIcon />
        </IconButton>
      </CustomTooltip>
      {!isCollapsed && (
        <CustomTooltip title={isExpanded ? 'Shrink participant list' : 'Expand participant list'}>
          <IconButton
            size="small"
            onClick={onToggleExpanded}
            aria-label={isExpanded ? 'shrink participant list' : 'expand participant list'}
          >
            <ChevronsIcon direction={isExpanded ? 'left' : 'right'} />
          </IconButton>
        </CustomTooltip>
      )}
    </Box>
  )
}

export default ParticipantListControls
